import React from 'react'

import {
    PAYMENT_CHECKOUT_URL,
} from '@bikemap/js/settings'
import { gettext } from '@bikemap/js/services'

import BasePromotionModal from '../BasePromotionModal.jsx'
import { getImageVariants } from '../helpers.js'

const identifier = 'lifetimedeal'
const plan = 'lifetime'
const percentage = 20
const voucher = 'ride20'

const Modal = () => {
    const trackingProps = '&utm_source=website&utm_medium=popup&utm_campaign=' + identifier
    const percentageString = percentage.toString() + '%'
    const modalProps = {
        label: gettext('{percentage} OFF')
            .replace('{percentage}', percentageString),
        title: gettext('Enjoy all exclusive features forever'),
        description: gettext('This Spring, treat yourself to a purchase that will last a lifetime. Just redeem your voucher code {voucher} to save {percentage} on your Lifetime membership and unlock all exclusive Bikemap Premium features forever. Only available for a very limited time!')
            .replace('{percentage}', percentageString)
            .replace('{voucher}', '<b>' + voucher.toUpperCase() + '</b>'),
        cta: gettext('Save {percentage} on Premium now')
            .replace('{percentage}', percentageString),
        imageAlt: gettext('Promotion'),
        img: getImageVariants('spring24'),
        ctaLink: PAYMENT_CHECKOUT_URL + '?plan=' + plan + '&voucher=' + voucher + '&skip-welcome=true' + trackingProps,
        finePrint: gettext('The voucher code {voucher} is valid until 1st of May, 2024.')
            .replace('{voucher}', voucher.toUpperCase()),
    }

    return (
        <BasePromotionModal
            premium
            {...modalProps}
        />
    )
}

export default Modal
